import { render, staticRenderFns } from "./PostTermReports.vue?vue&type=template&id=a1a25ca0"
import script from "./PostTermReports.vue?vue&type=script&lang=js"
export * from "./PostTermReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports